/* Original Renegade — optimized theme JS */
(function () {
  'use strict';

  function escapeHtml(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (char) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[char];
    });
  }

  function showToast(title, sub) {
    var toast = document.querySelector('.toast');
    if (!toast) return;
    toast.innerHTML = '<div class="toast__title">' + escapeHtml(title) + '</div>' + (sub ? '<div class="toast__sub">' + escapeHtml(sub) + '</div>' : '');
    toast.classList.add('is-visible');
    clearTimeout(toast._t);
    toast._t = setTimeout(function () { toast.classList.remove('is-visible'); }, 3000);
  }

  window.ORUpdateCartCount = function () {
    return fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('.site-header__cart-count').forEach(function (el) {
          el.textContent = cart.item_count;
          el.style.display = cart.item_count > 0 ? 'flex' : 'none';
        });
        return cart;
      });
  };

  var menuBtn = document.getElementById('menu-open');
  var menuClose = document.getElementById('menu-close');
  var mobileMenu = document.getElementById('mobile-menu');
  function closeMenu() {
    if (!mobileMenu) return;
    mobileMenu.classList.remove('is-open');
    document.body.style.overflow = '';
    if (menuBtn) menuBtn.setAttribute('aria-expanded', 'false');
  }
  if (menuBtn && mobileMenu) {
    menuBtn.addEventListener('click', function () {
      mobileMenu.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      menuBtn.setAttribute('aria-expanded', 'true');
    });
  }
  if (menuClose) menuClose.addEventListener('click', closeMenu);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && mobileMenu && mobileMenu.classList.contains('is-open')) closeMenu();
  });

  var atcBtn = document.getElementById('add-to-cart');
  if (atcBtn) {
    atcBtn.addEventListener('click', function (e) {
      e.preventDefault();
      var variantId = document.getElementById('selected-variant-id');
      var qty = document.getElementById('qty-input');
      if (!variantId || !variantId.value) {
        showToast('Please select a size', '');
        return;
      }
      atcBtn.disabled = true;
      atcBtn.textContent = 'Adding...';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(variantId.value, 10), quantity: parseInt(qty ? qty.value : 1, 10) || 1 }] })
      })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status) throw new Error(data.description || 'Could not add to cart');
        showToast('Added to Cart', data.title || '');
        return window.ORUpdateCartCount();
      })
      .catch(function (err) { showToast('Error', err.message || 'Something went wrong'); })
      .finally(function () {
        atcBtn.disabled = false;
        atcBtn.textContent = 'Add to Cart';
      });
    });
  }

  document.addEventListener('click', function (e) {
    if (!e.target.classList.contains('product-info__qty-btn')) return;
    var btn = e.target;
    var wrap = btn.closest('[data-qty-wrap]');
    var input = wrap ? wrap.querySelector('.product-info__qty-input') : null;
    if (!input) return;
    var val = parseInt(input.value, 10) || 1;
    if (btn.dataset.dir === 'up') val = Math.min(val + 1, 99);
    if (btn.dataset.dir === 'down') val = Math.max(val - 1, 1);
    input.value = val;
  });

  (function initCartQuantityControls() {
    var cartForm = document.querySelector('form[id^="ORCartForm-"]');
    if (!cartForm) return;
    var submitting = false;

    function submitCart() {
      if (submitting) return;
      submitting = true;
      if (typeof cartForm.requestSubmit === 'function') cartForm.requestSubmit();
      else cartForm.submit();
    }

    cartForm.addEventListener('click', function (e) {
      var btn = e.target.closest('.cart-item__qty-btn');
      if (!btn || !cartForm.contains(btn)) return;
      var wrap = btn.closest('[data-qty-wrap]');
      var input = wrap ? wrap.querySelector('.cart-item__qty-val') : null;
      if (!input) return;
      var value = parseInt(input.value, 10) || 1;
      if (btn.dataset.dir === 'up') value = Math.min(value + 1, 99);
      if (btn.dataset.dir === 'down') value = Math.max(value - 1, 1);
      input.value = value;
      submitCart();
    });

    cartForm.addEventListener('change', function (e) {
      if (!e.target.classList.contains('cart-item__qty-val')) return;
      var value = parseInt(e.target.value, 10) || 1;
      e.target.value = Math.max(1, Math.min(value, 99));
      submitCart();
    });
  })();

  document.querySelectorAll('.cart-item__remove').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var key = this.dataset.key;
      if (!key) return;
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: 0 })
      }).then(function () { window.location.reload(); });
    });
  });

  (function initStickyATC() {
    var stickyBar = document.getElementById('sticky-atc');
    if (!stickyBar) return;
    var stickyBtn = stickyBar.querySelector('.sticky-atc__btn');

    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        var variantId = document.getElementById('selected-variant-id');
        var qty = document.getElementById('qty-input');
        if (!variantId || !variantId.value) {
          showToast('Select a size first', '');
          return;
        }
        stickyBtn.disabled = true;
        stickyBtn.textContent = 'Adding…';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(variantId.value, 10), quantity: parseInt(qty ? qty.value : 1, 10) || 1 }] })
        })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (data.status) throw new Error(data.description || 'Could not add to cart');
          stickyBtn.textContent = 'Added ✓';
          return window.ORUpdateCartCount();
        })
        .catch(function () { stickyBtn.textContent = 'Error'; })
        .finally(function () {
          setTimeout(function () {
            stickyBtn.textContent = 'Add to Cart';
            stickyBtn.disabled = false;
          }, 1600);
        });
      });
    }
  })();

  (function initSearch() {
    var toggle = document.getElementById('search-toggle');
    var overlay = document.getElementById('search-overlay');
    var backdrop = document.getElementById('search-backdrop');
    var input = document.getElementById('search-input');
    var closeBtn = document.getElementById('search-close');
    var resultsEl = document.getElementById('search-results');
    if (!toggle || !overlay || !input || !resultsEl) return;
    var timer = null;
    var lastQuery = '';
    function openSearch() {
      overlay.classList.add('is-open');
      if (backdrop) backdrop.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      toggle.setAttribute('aria-expanded', 'true');
      setTimeout(function () { input.focus(); }, 80);
    }
    function closeSearch() {
      overlay.classList.remove('is-open');
      if (backdrop) backdrop.classList.remove('is-open');
      document.body.style.overflow = '';
      toggle.setAttribute('aria-expanded', 'false');
      input.value = '';
      resultsEl.innerHTML = '';
      lastQuery = '';
    }
    function money(cents) { return '£' + (cents / 100).toFixed(2); }
    function render(products, query) {
      var safeQuery = escapeHtml(query);
      if (!products.length) { resultsEl.innerHTML = '<p class="search-overlay__empty">No results for "' + safeQuery + '"</p>'; return; }
      var html = '<p class="search-overlay__status">' + products.length + ' result' + (products.length !== 1 ? 's' : '') + ' for "' + safeQuery + '"</p><div class="search-results-grid">';
      products.forEach(function (p) {
        var imageUrl = p.featured_image ? p.featured_image.url : '';
        if (imageUrl) imageUrl += imageUrl.indexOf('?') > -1 ? '&width=360' : '?width=360';
        var title = escapeHtml(p.title || '');
        var url = escapeHtml(p.url || '#');
        html += '<a href="' + url + '" class="search-result-item">';
        html += imageUrl ? '<div class="search-result-item__img"><img src="' + escapeHtml(imageUrl) + '" alt="' + title + '" width="180" height="180" loading="lazy" decoding="async"></div>' : '<div class="search-result-item__img"></div>';
        html += '<div class="search-result-item__info"><p class="search-result-item__title">' + title + '</p>' + (p.price ? '<p class="search-result-item__price">' + money(p.price) + '</p>' : '') + '</div></a>';
      });
      html += '</div><a href="/search?type=product&q=' + encodeURIComponent(query) + '" class="search-overlay__view-all">View all results →</a>';
      resultsEl.innerHTML = html;
    }
    function search(query) {
      if (query.length < 2) { resultsEl.innerHTML = ''; return; }
      if (query === lastQuery) return;
      lastQuery = query;
      resultsEl.innerHTML = '<p class="search-overlay__status">Searching…</p>';
      fetch('/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=8&resources[options][fields]=title,product_type,variants.title,body')
        .then(function (r) { return r.json(); })
        .then(function (data) { render((data.resources && data.resources.results && data.resources.results.products) || [], query); })
        .catch(function () { resultsEl.innerHTML = '<p class="search-overlay__empty">Something went wrong</p>'; });
    }
    toggle.addEventListener('click', openSearch);
    if (closeBtn) closeBtn.addEventListener('click', closeSearch);
    if (backdrop) backdrop.addEventListener('click', closeSearch);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && overlay.classList.contains('is-open')) closeSearch(); });
    input.addEventListener('input', function () {
      clearTimeout(timer);
      var q = this.value.trim();
      timer = setTimeout(function () { search(q); }, 280);
    });
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && this.value.trim()) window.location.href = '/search?type=product&q=' + encodeURIComponent(this.value.trim());
    });
  })();

  window.quickAdd = function (variantId, btn) {
    btn.textContent = '...';
    btn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    })
    .then(function (r) { return r.json(); })
    .then(function (data) {
      if (data.status) throw new Error();
      btn.textContent = 'Added ✓';
      return window.ORUpdateCartCount();
    })
    .catch(function () { btn.textContent = 'Error'; })
    .finally(function () {
      setTimeout(function () { btn.textContent = 'Quick Add'; btn.disabled = false; }, 1800);
    });
  };

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.js-quick-add');
    if (!btn) return;
    e.preventDefault();
    var variantId = parseInt(btn.dataset.variantId, 10);
    if (variantId) window.quickAdd(variantId, btn);
  });

  var contactForm = document.getElementById('ContactForm');
  if (contactForm) {
    contactForm.addEventListener('submit', function (e) {
      var trap = contactForm.querySelector('.contact-trap');
      if (trap && trap.value !== '') e.preventDefault();
    });
  }
})();
